<div class="container-fluid" >
    <div class="row" style="padding: 0px !important;margin: 0px !important;">
        <div class="col-2" style="padding: 0px !important;margin: 0px !important;">
            <img [src]="topup.image_url" alt="" width="40px" height="auto" style="padding-top: 5px;">
        </div>
        <div class="col-10 d-flex justify-content-start" style="padding: 0px !important;margin: 0px !important;">
            <h4>{{ 'topup1_confirm1' | translate}} {{topup.name}} {{ 'topup1_confirm2' | translate}}</h4>
        </div>
    </div>
   
</div>